import React from 'react';
import PropTypes from 'prop-types';

import {connect} from './connect';
class ControllerContainer extends React.Component {
  constructor(props) {
    super(props);
    const {component, factory, namespace, autoDisconnect, handleOnError} = props;
    if (!namespace) {
      throw new Error('Controllercontainer: namespace is required');
    }
    this.controller = factory(namespace, autoDisconnect);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.connectedComponent = connect(this.controller, {handleOnError})(component);
  }

  render() {
    const childProps = {...this.props};
    delete childProps.component;
    delete childProps.factory;
    delete childProps.autoDisconnect;
    delete childProps.namespace;

    return <this.connectedComponent {...childProps} />;
  }
}

ControllerContainer.propTypes = {
  component: PropTypes.node,
  factory: PropTypes.func,
  namespace: PropTypes.string,
  autoDisconnect: PropTypes.bool,
  handleOnError: PropTypes.func,
};

export default ControllerContainer;
